import { render, staticRenderFns } from "./GraduationPhoto.vue?vue&type=template&id=4f842536&scoped=true&"
import script from "./GraduationPhoto.vue?vue&type=script&lang=js&"
export * from "./GraduationPhoto.vue?vue&type=script&lang=js&"
import style0 from "./GraduationPhoto.vue?vue&type=style&index=0&id=4f842536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f842536",
  null
  
)

export default component.exports